import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const team = [
  { name: "Martin Burst", role: "Co-Founder & CEO", initials: "MB" },
  { name: "Roland Wagner", role: "Co-Founder & CTO", initials: "RW" },
  { name: "Christian Burst", role: "Co-Founder & Advisor", initials: "CB" },
];

const AboutTeam = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("aboutTeam.title")}</h2>
            <p className="text-lg text-muted-foreground">{t("aboutTeam.description")}</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <Card key={index} className="border-border/50 hover:shadow-lg transition-shadow text-center">
                <CardContent className="p-8">
                  <Avatar className="w-24 h-24 mx-auto mb-4">
                    <AvatarFallback className="bg-primary text-primary-foreground text-2xl font-bold">{member.initials}</AvatarFallback>
                  </Avatar>
                  <h3 className="text-xl font-semibold text-foreground mb-1">{member.name}</h3>
                  <p className="text-muted-foreground">{member.role}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTeam;
